<template>

<form
  class="mx-auto col-sm-12"
  @submit.prevent
>
  <b-alert
    :show="alert.show"
    @dismissed='alert.show = false'
    dismissible
    fade
    :variant="alert.type"
  >
    {{ alert.message }}
  </b-alert>

  <div class="row">
    <div class="form-group col-lg-6">
      <label for="serie">{{ $t('serie') }}</label>
      <input
        type="text"
        id="serie"
        name="serie"
        class="form-control"
        :placeholder="$t('ph_serie')"
        v-model="serial"
        v-validate="`required`"
      />
    </div>

    <div class="form-group col-lg-6" :class="{ 'has-error': errors.has('board') }">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      />

      <small v-show="errors.has('board')" class="form-text text-muted">
        {{ errors.first('board') }}
      </small>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="getVehicle"
      >
        {{ $t('search') }}
      </LoaderButton>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="vehicle"
        :fields='fieldsVehicle'
      >
        <template v-slot:cell(VEI_ID)={item}>
          <b-button
            size="sm"
            variant='primary'
            pill
            @click="defineVehicle(item.VEI_ID, item.EQP_SRN)"
          >
            Definir veículo para o Ativo
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</form>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'

export default {
  name: 'SearchVehicleForm',
  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      serial : '',
      board  : '',
      vehicle: [],
      fieldsVehicle: [
        {
          key: 'EQP_SRN',
          label: this.$t('serial')
        },
        {
          key: 'VEI_PLC',
          label: this.$t('board')
        },
        {
          key: 'CLI_COD',
          label: this.$t('client')
        },
        {
          key: 'CLI_DSC',
          label: this.$t('description')
        },
        {
          key: 'VEI_ID',
          label: '',
          class: ['w-25', 'text-center']
        }
      ],
      alert: {
        show   : false,
        type   : 'success',
        message: 'Definido veículo para o Ativo'
      }
    }
  },

  watch: {
    board: function(value) {
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (this.board.length === 3){
        this.board = value + '-'
      }

      if (this.board.length === 4 && !this.board.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    }
  },

  methods: {
    async getVehicle () {
      this.vehicle = await request({
        url   : `consult-vehicle`,
        method: 'get',
        params: {
          serial: this.serial,
          board : this.board
        }
      })
    },

    async defineVehicle(id, serial) {
      const { dispatch } = this.$store
      dispatch('overlay/show', true)

      try {
        await request({
          url   : `define-vehicle-active/${id}`,
          method: 'patch',
          data  : { serial }
        })

        this.alert.show = true
      } catch (error) {
        dispatch('notify/error', { message: error })
      } finally {
        dispatch('overlay/show', false)
      }
    }
  }
}
</script>